import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const PaperAirplaneIcon = ({
  color = 'white',
  width = 18,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M11.303 12.675l1.022.552-4.71 4.765 3.688-5.317zM16.283.071c.6-.276 1.237.292 1.083.965L14.82 12.172c-.12.527-.676.795-1.13.546l-3.226-1.764-1.525 2.643c-.416.722-1.464.41-1.464-.436v-2.944c0-.229.088-.448.245-.605l6.285-6.358c-.004-.078-.087-.146-.165-.088L6.337 8.697 3.817 7.32c-.59-.323-.563-1.229.047-1.51zM4.443 8.87l1.023.553L0 13.472 4.443 8.87z"
      />
    </svg>
  </DefaultIconWrapper>
);
